// Этот объект призван эмулировать стандартное поведение браузера,
// когда один и тот же скрипт не загружается дважды.
// Будьте осторожны если что-то меняете, потенциально учитывайте SSR, т.к. это может вызвать нежелательный шейринг данных между запросами.
// Сейчас этот общий стейт проблем не вызывает, т.к. загрузка скриптов вообще исключена на серверной стороне. (проверкой (typeof window === "undefined"))
const loadedScriptsMap: Record<string, Promise<unknown>> = {};

const loadScript = (
  src: string,
  options?: { async?: boolean; defer?: boolean },
): Promise<unknown> => {
  if (typeof window === "undefined") {
    return Promise.reject();
  }

  if (!loadedScriptsMap[src]) {
    loadedScriptsMap[src] = new Promise((resolve, reject) => {
      const script: HTMLScriptElement = document.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      script.onload = resolve;
      script.onerror = (err: string | Event) => {
        reject(err);
        document.body.removeChild(script);
      };
      script.async = options?.async || true;
      script.defer = options?.defer || false;
      document.body.appendChild(script);
    });
  }
  return loadedScriptsMap[src];
};

export default loadScript;
